export var AutoReindexTypes;
(function (AutoReindexTypes) {
    AutoReindexTypes[AutoReindexTypes["Off"] = 0] = "Off";
    AutoReindexTypes[AutoReindexTypes["PackBasedOnCount"] = 1] = "PackBasedOnCount";
    AutoReindexTypes[AutoReindexTypes["PackBasedOnPercent"] = 2] = "PackBasedOnPercent";
    AutoReindexTypes[AutoReindexTypes["PackBasedOnCountOrPercent"] = 3] = "PackBasedOnCountOrPercent";
})(AutoReindexTypes || (AutoReindexTypes = {}));
;
